import { ValidationTrigger, createManagerFactory, formBuilder } from 'app-components/utils/createForm/formBuilder';
import { createFormHooks } from 'app-components/utils/createForm/formHooks';

type FormData = {
  accountId?: string;
};
const init = ({ input }: { input: FormData; store?: any }) => {
  const initialValue = {
    ...input,
  };
  return initialValue;
};

export const profileFormFactory = createManagerFactory(
  formBuilder({ init })
    .addField('accountId', {
      selector: (state) => state.accountId || undefined,
      onValueChange: (draft, value: string | undefined) => {
        draft.accountId = value;
      },
      validation: {
        required: {
          triggers: ValidationTrigger.onSubmit | ValidationTrigger.onChange,
          isValid: (state) => Boolean(state?.accountId),
          error: () => 'Required field',
        },
      },
    })
    .build({
      submitTransform: (state) => state,
    }),
);

export const {
  FormProvider,
  InternalFormProvider,
  useField,
  useMultiFields,
  useIsDirty,
  useIsFormValid,
  useSelector,
  useManager,
} = createFormHooks(profileFormFactory);
